var map = {
	"./art.png": 8494,
	"./cloth.png": 9469,
	"./digital.png": 2896,
	"./event.png": 7408,
	"./health.png": 1090,
	"./industrial.png": 9447,
	"./sports.png": 5112,
	"./tools.png": 4757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4300;